import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client tuned for the Taquillera surface.
 *
 * Polling-first strategy (per ADR-T02): inventory + order.status are polled
 * every 5s on relevant pages instead of using Supabase Realtime WS. The WS
 * upgrade is a buffer-window task post-H7.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Avoid stampedes on focus; the user re-entering a tab during checkout
      // would otherwise re-trigger sensitive lookups.
      refetchOnWindowFocus: false,
      // 30s base staleness, individual queries can override (e.g. inventory = 5s).
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Don't retry on 4xx (idempotency violation, RLS denial, etc.)
        const status = (error as { status?: number } | null)?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      // Idempotency-Key is generated per checkout in src/store/cart.ts, so
      // retries are safe at the network layer — but we expose the failure to
      // the UI so the user sees a clear error state.
      retry: false,
    },
  },
});
